module.exports = __webpack_public_path__ + "static/media/Facebook.164175dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/agent/Tabs/Payments/img/Facebook.svg
// module id = 386
// module chunks = 16